

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface PackageModuleParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface PackageModule {
    id?: string;
  moduleId: string;
  packageId: string;
  parameters?: PackageModuleParameter[];
  links?: any;
}

export abstract class PackageModuleData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(): Observable<PackageModule[]>;
  abstract create(url: string,data: PackageModule): Observable<any>;
  abstract update(url: string,data: PackageModule): Observable<any>;
  abstract delete(url: string): Observable<any>;
  abstract moduleList(url: string): Observable<PackageModule[]>;

}
